import { useQuery } from "@tanstack/react-query";
import { getSection } from "../root/api/rootScreenApi";
import { Flex, SimpleGrid, Button, Text, Image } from "@chakra-ui/react";
import { Squiggle474x10Icon } from "../../components/icons/Squiggle474x10Icon";
import { Comic } from "../../types";
import { useIsSmallBreakpoint } from "../../utils/useBreakpoints";
import { Squiggle170x10Icon } from "../../components/icons/Squiggle170x10Icon";
import { useUserData } from "../../hooks/useUserData";
import { useNavigateToReaderWithContext } from "../reader/hooks/useNavigateToReaderWithContext";
import { FunnelContextArea } from "../../components/funnel/types";

export function Reccomendations({
  sectionSlug,
  handleCta,
}: {
  sectionSlug: string;
  handleCta?: () => void;
}) {
  const isSmallBreakpoint = useIsSmallBreakpoint();

  const { data } = useQuery({
    queryKey: ["reccomendations", sectionSlug],
    queryFn: () => {
      return getSection(sectionSlug);
    },
  });

  const arraySize = 8;
  const results =
    data?.data.payload.results.comics.slice(0, arraySize) ??
    Array(arraySize).fill(null);
  return (
    <Flex flexDirection="column" gap="24px" width="100%" alignItems="center">
      <Text variant="landingPageSectionTitle" textAlign="center">
        My want to read list
      </Text>
      {isSmallBreakpoint ? (
        <Squiggle170x10Icon width="172px" height="12px" color="blaze.blaze" />
      ) : (
        <Squiggle474x10Icon width="296px" height="13px" color="blaze.blaze" />
      )}
      <SimpleGrid columns={[2, 2, 2, 4, 4, 4]} spacing="32px" paddingTop="32px">
        {results
          ?.filter((c) => !!c)
          .map((comic: Comic, i) => (
            <Reccomendation key={i} comic={comic} handleCta={handleCta} />
          ))}
      </SimpleGrid>
    </Flex>
  );
}

export function Reccomendation({
  comic,
  handleCta,
}: {
  comic: Comic;
  handleCta?: () => void;
}) {
  const { userData } = useUserData();

  const { goToCTAUrl } = useNavigateToReaderWithContext({
    comicToNavigate: comic,
    area: FunnelContextArea.valkyrae,
  });

  const alcComics = [29526];

  const isUserGold = userData?.gold;
  return (
    <Flex flexDirection="column" flex="1" gap="24px">
      <Image
        borderRadius="8px"
        border="1px solid"
        borderColor="transparent.white.20"
        boxShadow="0px 20.956px 83.822px 0px var(--chakra-colors-transparent-black-80)"
        width="100%"
        src={comic.image_url}
        alt={comic.name}
        aspectRatio="217.00/328.46"
        onClick={
          isUserGold || alcComics.includes(comic.id) ? goToCTAUrl : handleCta
        }
        cursor="pointer"
        transition="transform 0.2s ease"
        _hover={{
          transform: "translateY(-4px)",
        }}
      />
      <Button
        variant="secondary"
        width="100%"
        height="32px"
        onClick={
          isUserGold || alcComics.includes(comic.id) ? goToCTAUrl : handleCta
        }
      >
        {alcComics.includes(comic.id)
          ? "Purchase to read"
          : isUserGold
            ? `Start reading`
            : "Subscribe to read"}
      </Button>
    </Flex>
  );
}
